import { select } from '@ngneat/elf';
import { getAuditsOperationDataSource } from '@store/audits/audits-operation/audit-operation.requests';
import { auditsOperationStore } from '@store/audits/audits-operation/audits-operation.store';

export class AuditsOperationQuery {
    store = auditsOperationStore;
    filters$ = this.store.pipe(select((state) => state.filters));

    auditsOperationList$ = getAuditsOperationDataSource.data$();
}

export const auditsOperationQuery = new AuditsOperationQuery();
